import React, { useEffect } from "react";
import { useAppContext } from "app/contexts/AppContext";
import {
  useAgendaEditor,
  AgendaEditorControls,
  AgendaEditorContent,
} from "./components/AgendaEditorPlugin";
import { updatePanelAgenda } from "app/apis/panels";
import { CIVIL_CASE_DIRECTOR_ROLE, CIVIL_CASE_TEAMLEADER_ROLE } from "app/utils/const";
import EmployeeProfile from "app/views/common_component/EmployeeProfile";
import { useTranslation } from "react-i18next";

const AgendaTab = ({ isDirectorOrHead }) => {
  const { t } = useTranslation();
  const { selectedPanel, setSelectedPanel } = useAppContext();
  const {
    isEditing,
    editedAgenda,
    isLoading,
    setEditedAgenda,
    startEditing,
    cancelEditing,
    setIsLoading,
  } = useAgendaEditor(selectedPanel?.agenda || "");

  useEffect(() => {
    setEditedAgenda(selectedPanel?.agenda || "");
  }, [selectedPanel, setEditedAgenda]);

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await updatePanelAgenda({ uu_id: selectedPanel?.uu_id, agenda: editedAgenda });
      const updatedPanel = { ...selectedPanel, agenda: editedAgenda };
      setSelectedPanel(updatedPanel);
      cancelEditing();
    } catch (error) {
      console.error("Error updating agenda:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!selectedPanel) return null;

  return (
    <div className="p-4 bg-gray-50 flex-1 overflow-y-auto mb-16">
      <div className="space-y-4 pl-2">
        <EmployeeProfile request={selectedPanel.created_by} />
        <div className="pl-4">
          <div className="flex justify-between items-center">
            <h3 className="text-[22px] font-semibold flex items-center space-x-2">
              <img src={`${process.env.PUBLIC_URL}/assets/agenda.svg`}
                // alt="Agenda" 
                alt={t('Agenda')}
                className="w-6 h-6" />
              <span className="text-gray-400">Agenda</span>
            </h3>
            {isDirectorOrHead && (
              <>
                {!selectedPanel.closed && (
                  <AgendaEditorControls
                    isEditing={isEditing}
                    isLoading={isLoading}
                    onStartEdit={startEditing}
                    onSave={handleSave}
                    onCancel={cancelEditing}
                  />
                )}
              </>
            )}
          </div>
          <AgendaEditorContent
            isEditing={isEditing}
            editedAgenda={editedAgenda}
            onAgendaChange={setEditedAgenda}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default AgendaTab;
